import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'
import { Box, Button, Flex, HStack, Heading, Select, Spacer } from '@chakra-ui/react'
import { IoIosRemoveCircleOutline } from 'react-icons/io'

const RemoveButton = ({ onClick }) => {
  return (
    <Box _hover={{ cursor: 'pointer' }} color="red.300" justifyContent={'center'} w="24px">
      <IoIosRemoveCircleOutline
        size={24}
        onClick={(e) => {
          e.stopPropagation()
          onClick()
        }}
      />
    </Box>
  )
}

export default RemoveButton
